import { Configuration, LogLevel, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { appConfig } from '../config/appConfig';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: appConfig.clientId,
    authority: `https://login.microsoftonline.com/${appConfig.tenantId}`,
    redirectUri: appConfig.redirectUri || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes for authentication - use openid to get ID token with roles
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Scopes for Microsoft Graph API (optional, if you need Graph data)
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

// Silent token request - openid returns ID token which includes roles
export const silentRequest: SilentRequest = {
  scopes: ['openid'],
  forceRefresh: false,
};
